export const MAP_LINES_Z_INDEX = 1000;
export const MAP_CIRCLES_Z_INDEX = 10000;
export const MAP_MARKERS_Z_INDEX = 20000;
export const MAP_CLUSTER_Z_INDEX = 30000;
